{
  "name": "adventlofliedere3",
  "version": "3.4.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "version:sync:en": "node scripts/sync-version.mjs capacitor/en",
    "version:sync:af": "node scripts/sync-version.mjs capacitor/af",
    "version:check:en": "node scripts/check-version.mjs capacitor/en",
    "version:check:af": "node scripts/check-version.mjs capacitor/af",
    "release:en": "node translation/changeLanguage.js en && npm run build && (cd capacitor/en && npx cap sync ios && npx cap sync android) && npm run version:sync:en && npm run version:check:en",
    "release:af": "node translation/changeLanguage.js af && npm run build && (cd capacitor/af && npx cap sync ios && npx cap sync android) && npm run version:sync:af && npm run version:check:af",
    "deploy": "node scripts/deploy.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.0",
    "@angular/cdk": "^18.0.4",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/forms": "^18.0.0",
    "@angular/material": "^18.0.3",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@awesome-cordova-plugins/android-full-screen": "^6.8.0",
    "@awesome-cordova-plugins/core": "^6.8.0",
    "@capacitor-community/keep-awake": "^5.0.0",
    "@capacitor/android": "^7.4.1",
    "@capacitor/app": "^7.0.1",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/browser": "^7.0.1",
    "@capacitor/cli": "^7.4.1",
    "@capacitor/core": "^7.4.1",
    "@capacitor/ios": "^7.4.1",
    "@capacitor/preferences": "^7.0.1",
    "@capacitor/share": "^7.0.1",
    "@capacitor/splash-screen": "^8.0.1",
    "@capacitor/status-bar": "^7.0.1",
    "@capacitor/text-zoom": "^7.0.1",
    "@capawesome/capacitor-screen-orientation": "^7.0.1",
    "@hugotomazi/capacitor-navigation-bar": "^4.0.1",
    "@meddv/ngx-pinch-zoom": "^20.0.0",
    "canvas-confetti": "^1.9.3",
    "capacitor-plugin-safe-area": "^5.0.0",
    "chordsheetjs": "^14.0.0",
    "cordova-plugin-fullscreen": "^1.3.0",
    "fuse.js": "^7.0.0",
    "install": "^0.13.0",
    "material-design-icons": "^3.0.1",
    "material-icons": "^1.13.12",
    "ng2-pdf-viewer": "^10.4.0",
    "npm": "^10.8.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.0.4",
    "@angular/cli": "^18.0.4",
    "@angular/compiler-cli": "^18.0.0",
    "@google/generative-ai": "^0.24.1",
    "@tonejs/midi": "^2.0.28",
    "@types/canvas-confetti": "^1.9.0",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.13.14",
    "basic-ftp": "^5.0.5",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "pdf2pic": "^3.2.0",
    "tsx": "^4.21.0",
    "typescript": "~5.4.2"
  }
}
